import { Chip, ChipProps, TextField, TextFieldProps } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { FC, useEffect, useState } from 'react';

interface IProps {
    initialKeywords?: Array<string>
    onKeywordsUpdate?: (keywords: Array<string>) => void;
    textFieldProps?: TextFieldProps;
    chipProps?: ChipProps;
    enableReinitialization?: boolean;
}

const KeywordsForm: FC<IProps> = (props) => {

    const { initialKeywords = [], enableReinitialization = false } = props;

    const [keywords, setKeywords] = useState<string[]>(initialKeywords);
    const [keywordField, setKeywordField] = useState('');

    useEffect(() => {
        if (enableReinitialization) setKeywords(initialKeywords);
    }, [initialKeywords, enableReinitialization])

    const addKeyword = (value: string) => {
        setKeywordField('');
        let updatedKeywords = keywords;
        if (updatedKeywords.indexOf(value) === -1 && value) {
            updatedKeywords.unshift(value);
            setKeywords(updatedKeywords);
            props.onKeywordsUpdate?.(updatedKeywords);
        }
    }

    const handleKeyPressed: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        addKeyword((e.target as HTMLInputElement)['value']);
    }

    const removeKeyword = (index: number) => {
        let updatedKeywords = [...(keywords || [])];
        updatedKeywords.splice(index, 1);
        setKeywords(updatedKeywords);
        props.onKeywordsUpdate?.(updatedKeywords);
    }

    const onClick = (i: number) => {
        setKeywordField(keywords[i]);
        removeKeyword(i);
    }

    useEffect(() => {
        let keywords = keywordField.split(',');
        if (keywords.length > 1) {
            keywords.forEach((item, index) => {
                if (index + 1 === keywords.length) {
                    setKeywordField(item);
                    return;
                };
                addKeyword(item);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [keywordField]);

    const classes = useStyles();

    return (
        <div className={classes.keywordsPaper} >
            <TextField
                label='Keywords'
                fullWidth
                name='keywordField'
                value={keywordField || ''}
                onKeyPress={handleKeyPressed}
                onChange={e => setKeywordField(e.target.value)}
                {...(props.textFieldProps || {})}
            />
            <div>
                {keywords.map((item, i) => (<Chip variant={'outlined'} key={i} label={item} onDelete={e => removeKeyword(i)} clickable onClick={() => onClick(i)} {...(props.chipProps || {})} />))}
            </div>
        </div>
    )
}

const useStyles = makeStyles<Theme>((theme) => {

    const { palette: { text } } = theme;

    return (createStyles({

        keywordsPaper: {
            paddingTop: 0,
            '& > div:nth-child(2)': {
                marginTop: 12,
                ' & > div': {
                    marginRight: 5,
                    marginBottom: 5,
                    color: text['primary']
                }
            }
        },
    }))
})

export default KeywordsForm;